/**
 * Reference Data Sets (SetID) routes — FSD 1.2.6.
 *
 * `src/router/index.ts` is wired by the orchestrator after every C14 W3
 * packet lands (this packet's brief, §"Scope boundaries"); this module only
 * declares its own record array for that later merge. Every route is gated on
 * the **read** permission (`foundation.refset.read`) so Internal Audit — who
 * FSD 1.2.6.1 names as holding only read access — can open every screen here.
 */

import type { RouteRecordRaw } from 'vue-router'

import { REFERENCE_SET_PERMISSIONS } from './permissions'

export const REFERENCE_SET_ROUTES: RouteRecordRaw[] = [
  {
    path: '/enterprise/reference-sets',
    name: 'enterprise-reference-sets',
    component: () => import('./ReferenceSetsView.vue'),
    meta: {
      titleKey: 'enterprise.referenceSets.routeTitles.catalogue',
      permission: REFERENCE_SET_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/reference-sets/compare',
    name: 'enterprise-reference-sets-compare',
    component: () => import('./CompareSetsView.vue'),
    meta: {
      titleKey: 'enterprise.referenceSets.routeTitles.compare',
      permission: REFERENCE_SET_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/reference-sets/visibility',
    name: 'enterprise-reference-sets-visibility',
    component: () => import('./VisibilityView.vue'),
    meta: {
      titleKey: 'enterprise.referenceSets.routeTitles.visibility',
      permission: REFERENCE_SET_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/reference-sets/determinants',
    name: 'enterprise-reference-sets-determinants',
    component: () => import('./DeterminantsView.vue'),
    meta: {
      titleKey: 'enterprise.referenceSets.routeTitles.determinants',
      permission: REFERENCE_SET_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/reference-sets/browse',
    name: 'enterprise-reference-sets-browse',
    component: () => import('./ReferenceDataBrowserView.vue'),
    meta: {
      titleKey: 'enterprise.referenceSets.routeTitles.browse',
      permission: REFERENCE_SET_PERMISSIONS.read,
    },
  },
]
